import * as React from "react";
import { tv } from "tailwind-variants";
import ListItem, { ListItemProps } from "./ListItem";

const ListVariant = tv({
  slots: {
    base: "bg-surface-default rounded-2xl border-solid border-border-subdued border p-1.5 flex flex-col items-start justify-start w-full relative",
  },
  variants: {
    borderless: {
      true: {
        base: "border-none",
      },
    },
  },
});
interface ListProps {
  data: ListItemProps[];
  divider?: boolean;
  borderless?: boolean;
}

const List: React.FC<ListProps> = ({ borderless, data, divider }) => {
  const { base } = ListVariant({ borderless });

  return (
    <div className={base()}>
      <div className="flex flex-col justify-start relative w-full">
        {data.map((item, index) =>
          item.props ? (
            item
          ) : (
            <ListItem
              {...item}
              divider={divider !== undefined ? divider : true}
              key={index}
              index={index}
            />
          )
        )}
      </div>
    </div>
  );
};

export default List;
